import React from 'react';
import { Input } from 'clarifai-web-grpc/proto/clarifai/api/resources_pb';
import { usePopoverState, PopoverAction } from 'components/Popover';
import { inputBarActions } from 'components/InputActionBar/actions';
import InputInfoPopover from 'components/InputInfoPopover';

export const InfoButton = ({ currentInput }: { currentInput: Input | null }) => {
  const metadataPopover = usePopoverState({ placement: 'right-end' });
  return (
    <>
      <PopoverAction popover={metadataPopover}>
        <inputBarActions.InputInfoButton />
      </PopoverAction>
      {/* force render to reset the ui state */}
      {metadataPopover.visible && <InputInfoPopover popover={metadataPopover} currentInput={currentInput} />}
    </>
  );
};
